module.exports = __webpack_public_path__ + "img/1498990492.ff7e9486.jpg";